/**
 * Catálogo do módulo Relatórios (/erp/relatorios).
 */

import { TrendingUp, ShoppingCart, Package } from 'lucide-react';
import type { ErpIcon } from './erpNavigation';
import { MODULES, ACTIONS } from '../hooks/usePermissions';

export interface ErpReportCatalogItem {
  id: string;
  label: string;
  description: string;
  path: string;
  icon: ErpIcon;
  color: string;
  category: string;
  module: string;
  action: string;
  /** Se false, aparece como "Em breve" (não navega). */
  enabled: boolean;
}

export const ERP_REPORTS_CATALOG: ErpReportCatalogItem[] = [
  {
    id: 'contas-receber',
    label: 'Contas a Receber',
    description: 'Títulos a receber por período, status e cliente — PDF no padrão financeiro',
    path: '/erp/relatorios/contas-receber',
    icon: TrendingUp,
    color: 'bg-emerald-600',
    category: 'Financeiro',
    module: MODULES.REPORTS,
    action: ACTIONS.REPORTS_RECEIVABLES,
    enabled: true,
  },
  {
    id: 'vendas',
    label: 'Vendas',
    description: 'Vendas por período, status, cliente e vendedor — PDF completo',
    path: '/erp/relatorios/vendas',
    icon: ShoppingCart,
    color: 'bg-blue-600',
    category: 'Operacional',
    module: MODULES.REPORTS,
    action: ACTIONS.REPORTS_SALES,
    enabled: true,
  },
  {
    id: 'estoque',
    label: 'Estoque',
    description: 'Saldo atual por produto — físico, reservado e disponível',
    path: '/erp/relatorios/estoque',
    icon: Package,
    color: 'bg-amber-600',
    category: 'Operacional',
    module: MODULES.REPORTS,
    action: ACTIONS.REPORTS_STOCK,
    enabled: true,
  },
];

export function getEnabledReports() {
  return ERP_REPORTS_CATALOG.filter((item) => item.enabled);
}
